import { gradingIdSchema } from "@repo/app-types/entities/teammatePerformanceSummary";
import { z } from "zod";
import { usePrefillFromUrl } from "../../hooks/usePrefillFromUrl.js";

const callFeedbackPrefillSchema = z.object({
  gradingId: gradingIdSchema,
  sentiment: z.enum(["positive", "negative"]),
  commentary: z.string(),
});

/**
 * The call feedback a reviewer left before choosing "Edit agent", carried to
 * the agent page in the `prefill` query param and turned into the first
 * message of an Ask Alpharun thread.
 */
export type CallFeedbackPrefill = z.infer<typeof callFeedbackPrefillSchema>;

export function useCallFeedbackPrefillFromUrl(): CallFeedbackPrefill | null {
  return usePrefillFromUrl(callFeedbackPrefillSchema);
}

/** Build the message to send when auto-starting a conversation from prefill data */
export function buildCallFeedbackPrefillMessage(
  prefill: CallFeedbackPrefill,
): string {
  const sentimentLabel =
    prefill.sentiment === "positive" ? "positive" : "negative";

  return `I just reviewed a call and left ${sentimentLabel} feedback:
"${prefill.commentary}"

Here's the call I was reviewing: ${prefill.gradingId}

Can you help me update my agent based on this feedback?`;
}
